import { UiActionType, UiAction, UiState } from './types';

const initialState = {
  globalMenuOpen: false,
  onboardingNavigationOverlayOpen: false,
  workbooksMenuOpen: false,
  globalMenuWidth: 0,
  isDeviceCompatible: true,
  isLoadingContent: false,
  selectedSubmenu: '',
  pageSelectorMenuOpen: false,
  selectedClassroomId: '',
  menuOpen: false
};

const ui = (state: UiState = initialState, action: UiAction) => {
  switch (action.type) {
    case UiActionType.TOGGLE_GLOBAL_MENU:
      return {
        ...state,
        globalMenuOpen: !state.globalMenuOpen
      };
    case UiActionType.TOGGLE_ONBOARDING_NAVIGATION_MENU_OVERLAY:
      return {
        ...state,
        onboardingNavigationOverlayOpen: !state.onboardingNavigationOverlayOpen
      };
    case UiActionType.TOGGLE_SUBMENU:
      return {
        ...state,
        selectedSubmenu: action.data
      };
    case UiActionType.SET_GLOBAL_MENU_WIDTH:
      return {
        ...state,
        globalMenuWidth: action.data
      };
    case UiActionType.TOGGLE_WORKBOOKS_MENU:
      return {
        ...state,
        workbooksMenuOpen: !state.workbooksMenuOpen
      };
    case UiActionType.TOGGLE_WORKBOOK_PAGE_SELECTOR_MENU:
      return {
        ...state,
        pageSelectorMenuOpen: !state.pageSelectorMenuOpen
      };
    case UiActionType.CLOSE_MENU:
      return {
        ...state,
        [action.data]: false
      };
    default:
      return state;
  }
};

export default ui;
